import React, { useEffect, useState } from "react";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography, Box, Checkbox } from "@mui/material";
import CustomCheckbox from "./CustomCheckbox"; 
import data from "./data"; // You can move your data to a separate file  
import ManualRow from "./ManualRow"; 
import ManualSkeleton from "./ManualSkeleton";
import NoData from "../../../components/NoData/NoData";

const cellStyle = {
    padding: '10px 16px',
};

const ManualTable = ({ isMeView = false, isAllView = false }) => {
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);  // Ensure this gets called
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    const handleSelectAll = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((row) => row.id));
        }
    };

    const handleRowToggle = (id) => () => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const allSelected = selectedRows.length === data.length;
    const someSelected = selectedRows.length > 0 && !allSelected;

    return (
        <> 
          <Box display="flex" alignItems="center" gap={2} className="showSummaryCs" sx={{ padding: '0px 0 12px 0', }}>
                <Box component="li" sx={{ listStyle: 'none' }}>
                  <Typography variant="body2">
                    <Box component="span" fontWeight="400" sx={{ fontSize: '12px', background: '#004DFF', borderRadius: '50px', color: '#fff', padding: '6px 16px 6px 16px' }}>Changes made Tue, Apr 1, 2025</Box>
                  </Typography>
                </Box>
                <Box component="li" sx={{ listStyle: 'none' }}>
                  <Typography variant="body2" sx={{ color: '#9095A1', fontSize: '14px', }}>
                  Hours added:  <Box component="span" fontWeight="bold" sx={{ color: '#004DFF', }}>0:41:00 </Box>
                  </Typography>
                </Box>
                <Box component="li" sx={{ listStyle: 'none' }}>
                  <Typography variant="body2" sx={{ color: '#9095A1', fontSize: '14px', }}>
                   Hours deleted:  <Box component="span" fontWeight="bold" sx={{ color: '#004DFF', }}>0:11:45</Box>
                  </Typography>
                </Box> 
              </Box>

            <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent', marginBottom: '24px' }}>
                <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 5px' }}>
                    <TableHead sx={{ backgroundColor: '#DFDFDF' }}>
                        <TableRow>
                            <TableCell sx={{
                                ...cellStyle,
                                border: 'none',
                                minWidth: '50px',
                                maxWidth: '32px',
                                borderTopLeftRadius: '10px',
                                borderBottomLeftRadius: '10px'
                            }}>
                                <CustomCheckbox
                                    checked={allSelected}
                                    indeterminate={someSelected}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center', }}>#</TableCell>
                             {!isMeView && (<TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Members</TableCell> )}
                            {!isAllView && (<TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Project</TableCell>)} 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Action</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left',whiteSpace:'nowrap' }}>Changed by</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Changed at</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Time Span</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Time change</TableCell>  
                            <TableCell sx={{
                                ...cellStyle,
                                border: 'none',
                                borderTopRightRadius: '10px',
                                borderBottomRightRadius: '10px',
                                textAlign: 'center',
                                whiteSpace:'nowrap'
                            }}>
                               Reason
                            </TableCell>
                        </TableRow>
                    </TableHead> 
                    <TableBody>
                        {loading ? (
                            [...Array(3)].map((_, i) => <ManualSkeleton key={i} isMeView={isMeView} />)
                        ) : data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={9} align="center" sx={{ padding: '40px 16px' }}>
                                    <NoData />
                                </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row) => (
                                <ManualRow
                                    key={row.id}
                                    row={row}
                                    isSelected={selectedRows.includes(row.id)}
                                    onSelectToggle={handleRowToggle(row.id)}
                                    isMeView={isMeView}
                                    isAllView={isAllView}
                                />
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default ManualTable;